import Styles from "./styles";

const compose = (classes) => {
  const css = {};
  const classesArray = classes.trim().split(/\s+/);

  classesArray.forEach((className) => {
    if (Styles[className] !== undefined) {
      Object.assign(css, Styles[className]);
    }
  });

  return css;
};

export default compose;
